export const ROW_HEIGHT_PX_COMPACT = {
    small: 30,
    default: 34,
    large: 38,
};

export const ROW_HEIGHT_PX = {
    small: 42,
    default: 46,
    large: 50,
};
